import KeenSlider from 'keen-slider'

const CarouselId = 'carousel';

const init = () => {

  if(!document.getElementById(CarouselId)) {
    return;
  }

  const slider = new KeenSlider(`#${CarouselId}`, {
    loop: true,
    created: function(instance) {
      document
        .getElementById("keen-prev")
        .addEventListener("click", function() {
          instance.prev();
        });

      document
        .getElementById("keen-next")
        .addEventListener("click", function() {
          instance.next();
        });
    },
  });
};

export default {init};
